import React, { useState } from 'react';
import { TemplatePromoList } from './TemplatePromoList';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { gAPI_CopyPromo } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

function TemplatePromoButton({ propertyId, LoadData }) {
    const [visible, setVisible] = useState(false);
    const handleSubmit = data => {
        AxiosAPI({
            method: 'post',
            url: `${gAPI_CopyPromo}`,
            data,
        })
            .then(
                res => {
                    setVisible(!visible)
                    LoadData();
                }
            )
            .catch(err => {
                console.log('err', err);
            });
    };

    return (
        <div>
            <Button
                color="primary"
                outline
                size="xs"
                onClick={() => {
                    setVisible(!visible);
                }}
                style={{ width: '100%', borderRadius: '6px' }}
            >
                + Add From Templates
      </Button>

            <TemplatePromoList
                formLabel="Template Promo List"
                visible={visible}
                toggle={() => {
                    setVisible(!visible);
                }}
                submit={handleSubmit}
                propertyId={propertyId}
            />
        </div>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(TemplatePromoButton));

TemplatePromoButton.propTypes = {
    propertyId: PropTypes.string.isRequired,
};
